// The company page opens the Evidence tab on the named storefront; the operator comes back to this tab.
export const storefrontSetupHref = ({ companyId, storefrontId }: { companyId: number; storefrontId: number | null }) =>
  `/companies?companyId=${companyId}&tab=evidence${storefrontId === null ? "" : `&storefront=${storefrontId}`}`;
